var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFlagUsa(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_114_28718)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14 28.5C21.732 28.5 28 22.232 28 14.5C28 6.76801 21.732 0.5 14 0.5C6.26801 0.5 0 6.76801 0 14.5C0 22.232 6.26801 28.5 14 28.5Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3916 14.4999H28.0003C28.0003 13.2362 27.8318 12.0121 27.518 10.8477H13.3916V14.4999Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.3916 7.19516H25.9454C25.0884 5.7967 23.9927 4.56059 22.7151 3.54297H13.3916V7.19516Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M13.9999 28.5005C17.2948 28.5005 20.3232 27.3617 22.7147 25.457H5.28516C7.67664 27.3617 10.7051 28.5005 13.9999 28.5005Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.05496 21.8045H25.9453C26.6333 20.6819 27.1669 19.4547 27.5178 18.1523H0.482422C0.833352 19.4547 1.36694 20.6819 2.05496 21.8045Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.48506 2.6863H7.76087L6.57415 3.54845L7.02745 4.94347L5.84079 4.08132L4.65412 4.94347L5.04569 3.73832C4.00083 4.60867 3.08503 5.62838 2.33034 6.76456H2.73913L1.98373 7.31335C1.86605 7.50968 1.75317 7.70912 1.645 7.91152L2.00572 9.02173L1.33273 8.53277C1.16545 8.8872 1.01243 9.24962 0.874891 9.61958L1.2723 10.8428H2.73913L1.55241 11.705L2.00572 13.1L0.819055 12.2379L0.108227 12.7543C0.0370781 13.3262 0 13.9088 0 14.5H14C14 6.76806 14 5.85653 14 0.5C11.2343 0.5 8.65621 1.30227 6.48506 2.6863ZM7.02745 13.1L5.84079 12.2379L4.65412 13.1L5.10743 11.705L3.92071 10.8428H5.38754L5.84079 9.44781L6.29404 10.8428H7.76087L6.57415 11.705L7.02745 13.1ZM6.57415 7.62671L7.02745 9.02173L5.84079 8.15959L4.65412 9.02173L5.10743 7.62671L3.92071 6.76456H5.38754L5.84079 5.36954L6.29404 6.76456H7.76087L6.57415 7.62671ZM12.0492 13.1L10.8625 12.2379L9.67586 13.1L10.1292 11.705L8.94244 10.8428H10.4093L10.8625 9.44781L11.3158 10.8428H12.7826L11.5959 11.705L12.0492 13.1ZM11.5959 7.62671L12.0492 9.02173L10.8625 8.15959L9.67586 9.02173L10.1292 7.62671L8.94244 6.76456H10.4093L10.8625 5.36954L11.3158 6.76456H12.7826L11.5959 7.62671ZM11.5959 3.54845L12.0492 4.94347L10.8625 4.08132L9.67586 4.94347L10.1292 3.54845L8.94244 2.6863H10.4093L10.8625 1.29127L11.3158 2.6863H12.7826L11.5959 3.54845Z",
    fill: "#0052B4"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_114_28718"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 28,
    height: 28,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFlagUsa);
export default __webpack_public_path__ + "static/media/flag-usa.4d9e213eebc6489ad1f1b3997571c114.svg";
export { ForwardRef as ReactComponent };